import { render, staticRenderFns } from "./download-work-permit-dialog.component.vue?vue&type=template&id=8210ab26"
import script from "./download-work-permit-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./download-work-permit-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports